





































































































import Vue from 'vue';
import SidePage from 'common/components/ui/SidePage/index.vue';
import customerClient from '../../apis';
import UploadExcel from 'common/components/ui/UploadExcel/index.vue';
import { TaskType } from '../../../common/models/TaskType';
import commonClient from '../../../common/apis';

const excelUrl: string | null = null;
const openids: string | null = null;
const indexStatuses: boolean[] | null = null;
const appendRemarkName: string | null = null;

export default Vue.extend({
  components: {
    SidePage,
    UploadExcel,
  },
  data() {
    return {
      isExcel: false,
      importing: false,
      openids,
      appendRemarkName,
      indexStatuses,
      uploadUrl: 'api-crm-web/customer/uploadRemarkExcel',
      excelUrl,
      perviewData: null,
    };
  },
  computed: {
    pasteOpenids(): string[] {
      if (this.openids) {
        return this.openids.split('\n');
      } else {
        return [];
      }
    },
  },
  methods: {
    afterUpload(item: any) {
      if (!this.excelUrl) {
        this.excelUrl = item.excelUrl;
        this.perviewData = item.peek;
      }
    },
    validateOpenids() {
      const regx = /^[0-9a-zA-Z\-\_]{1,40}$/;
      let valid = true;
      this.indexStatuses = [];
      for (const openid of this.pasteOpenids) {
        if (!regx.test(openid)) {
          valid = false;
          this.indexStatuses.push(false);
        } else {
          this.indexStatuses.push(true);
        }
      }
      if (!this.pasteOpenids || this.pasteOpenids.length < 1) {
        valid = false;
      }
      return valid;
    },
    validateRemarkName() {
      return this.appendRemarkName &&
        this.appendRemarkName.trim() !== '';
    },
    confirmImport() {
      if (this.isExcel) {
        this.doImportViaExcel();
      } else {
        this.doImportFromPasting();
      }
    },
    doImportFromPasting() {
      if (!this.validateRemarkName()) {
        this.$Message.warning('标签名不能为空');
        return;
      } else if (!this.validateOpenids()) {
        this.$Message.warning('OpenID格式不正确');
        return;
      } else {
        this.importing = true;
        customerClient.batchAppendRemark({
          openids: this.pasteOpenids,
          remark: this.appendRemarkName!.trim(),
        }).success(r => {
          this.$Message.success('导入成功');
          this.$emit('success');
        }).failure((code: string, msg?: string) => {
          this.$Message.error(msg);
        }).error((e) => {
          this.$Message.error(e.toString());
        }).done(() => {
          this.importing = false;
        });
      }
    },
    doImportViaExcel() {
      if (!this.excelUrl) {
        this.$Message.warning('请上传Excel文件');
        return false;
      }
      this.importing = true;
      commonClient.createTask({
        input: {
          RemarkImport: {
            excelUrl: this.excelUrl,
          },
        },
        expectCount: 0,
        taskType: TaskType.RemarkImport,
      }).success((r) => {
        this.$Message.success('任务已创建，请等待结果');
        this.$emit('close');
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      }).done(() => {
        this.importing = false;
      });
    },
  },
});
